import { Common, ApiBind } from './common.model';

export class TesterValue extends Common {

  @ApiBind({ column: 'tester_id' })
  id: number;
}
